import { SearchIcon } from '@/components/Icons'

interface AdminSearchInputProps {
  value: string
  placeholder: string
  onChange: (value: string) => void
}

/**
 * Debounced-search text box styled for the admin toolbar. Grows to fill the
 * row on wide screens and drops to full width when the toolbar wraps.
 * Debouncing itself is handled by `useAdminTable`; this is purely the
 * controlled input.
 */
export default function AdminSearchInput({ value, placeholder, onChange }: AdminSearchInputProps) {
  return (
    <div className="relative w-full min-w-[12rem] flex-1 sm:max-w-sm">
      <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[var(--text-secondary)]" />
      <input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className="h-10 w-full rounded-lg border border-[var(--border-hover)] bg-[var(--bg-secondary)] pl-9 pr-3 text-sm text-[var(--text-primary)] shadow-[var(--shadow-sm)] transition-colors placeholder:text-[var(--text-tertiary)] focus:border-[var(--accent)] focus:outline-none focus:ring-2 focus:ring-[var(--ring)]"
      />
    </div>
  )
}
